// src/services/api/bulkOrderSettings.js
import { apiClient } from './base';

const NAMESPACE = 'bulkOrder';

export const getBulkOrderSettings = async () => {
  try {
    const response = await apiClient.get(`/business-settings/${NAMESPACE}`);
    return response.data.settings || {};
  } catch (error) {
    throw error;
  }
};

export const saveBulkOrderSettings = async (settings) => {
  try {
    const response = await apiClient.put(`/business-settings/${NAMESPACE}`, { settings });
    return response.data.settings;
  } catch (error) {
    throw error;
  }
};